export const TelegramIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_618_2957)">
                <path
                    d="M22.0517 2.12998L0.788779 10.3718C-0.0668777 10.7556 -0.356284 11.5243 0.581966 11.9414L6.03681 13.6839L19.2259 5.49059C19.9461 4.97623 20.6833 5.11339 20.0489 5.67922L8.72125 15.9887L8.36542 20.3516C8.695 21.0253 9.29847 21.0284 9.6834 20.6936L12.8174 17.7128L18.1848 21.7528C19.4314 22.4947 20.1098 22.016 20.378 20.6563L23.8985 3.89984C24.2641 2.22617 23.6407 1.48873 22.0517 2.12998Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_618_2957">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
